import React from "react";
import "./node.css";

export const OrgNode = ({ nodeData, addChildren, setCollapse }) => {
  return (
    <div>
      <div className="fullname">{nodeData.name}</div>
      <div className="info">{nodeData.area}</div>
      <div className="info">{nodeData.position}</div>
    </div>
  );
};
